import React from "react";
import PropTypes from 'prop-types';
import { action, observable } from "mobx";
import { defaultTemplate } from 'core/hoc';
import { setCurrentView } from "core/utils";
import { TableFilterTemplate } from "themes/components";

const TableFilter = function(props) {
    return <TableFilterTemplate {...props} />;
};

TableFilter.propTypes = {
    queryUtility: PropTypes.object.isRequired,
    showClear: PropTypes.bool,
    // onFilterVisibilityChange: PropTypes.func
};

export default setCurrentView(
    (rootStore, props) => new TableFilterStore(rootStore, props),
    "filterStore"
)(defaultTemplate(TableFilter));

class TableFilterStore {
    @observable accessor filterVisible = false;

    constructor(rootStore, props) {

        this.rootStore = rootStore;
        this.defaultVisability = !!props.filterVisible;
        // Initialize AFTER defaultVisability is computed — class field initializers run
        // before the constructor body, which is the opposite of MobX 4's @observable
        // decorator semantics. Setting it here keeps the original initial-state intent.
        this.filterVisible = this.defaultVisability;
        if (props.onFilterVisibilityChange) {
            this.onFilterVisibilityChange = props.onFilterVisibilityChange;
        }
    }

    @action.bound
    toggleFilterVisibility() {
        this.filterVisible = !this.filterVisible;
        if (this.onFilterVisibilityChange) {
            this.onFilterVisibilityChange(this.filterVisible);
        }
    }
}
